
import React from 'react';
import { Images } from '../../constants';

const Technology = () => {
  return (
    <div className='bg-[#F3F3F3] pb-6 flex flex-col select-none'>
      <div className='justify-center flex item-center'>
        <h1 className='poppins-bold text-[#3D3D3D] py-2'>TECHNOLOGY WE USED</h1>
      </div>
      <div className='p-5 flex flex-wrap justify-center'>
        <div className="grid grid-cols-3 md:grid-cols-7 gap-16">
          <img draggable="false"   src={Images.NODEJS} alt="Node.js" className="w-full md:w-auto" />
          <img draggable="false"   src={Images.REACTJS} alt="React.js" className="w-full md:w-auto" />
          <img draggable="false"   src={Images.MONGODB} alt="MongoDB" className="w-full md:w-auto" />
          <img draggable="false"   src={Images.TAILWIND} alt="Tailwind CSS" className="w-full md:w-auto" />
          <img draggable="false"   src={Images.REACT_NATIVE} alt="React Native" className="w-full md:w-auto" />
          <img draggable="false"   src={Images.FIGMA} alt="Figma" className="w-full md:w-auto" />
          
        </div>
      </div>
    </div>
  );
}

export default Technology;
